<template>
    <div>
        <!-- signature structure  -->
        <b-media class="" @click="openSignature('supervisor')" v-if="crewSign.image == null">
                                                    
            <b-avatar ref="supervisorS" :src="doc_icon" variant="light-info" rounded style="background: #ffffff; height: 160px; width: auto"/>

            <div class="d-flex flex-wrap">
                <input ref="supervisorSInput" type="file" class="d-none" @input="crewUpload" >
            </div>

        </b-media>

        <img :src="crewSign.image" v-if="crewSign.image != null" class="rounded" style="background: #ffffff; height: 160px; width: auto">
        <br/>
        <b-button variant="danger" class="mt-1" v-if="crewSign.image != null" @click="removeSign('supervisor')">
            <feather-icon icon="XIcon" />
        </b-button>

        <!-- signature Model -->
        <b-modal centered hide-footer
            id="signatureModelCrew"
            ref="signatureModelCrew"
            title="Signature"
            no-close-on-backdrop
            @hide="hideSigantureCrew"
            @show="hideSigantureCrew"
        >
            <b-row>
                <b-col md="12">
                    <VueSignaturePad
                        id="signature"
                        width="100%"
                        height="300px"
                        ref="signaturePad"
                        :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()},penColor: '#000000',minWidth: 3,maxWidth: 3 }"
                    />
                </b-col>
            </b-row>

            <b-row class="mt-2">

                <b-col md="4">
                    <b-button variant="primary" class="mt-0 w-100" @click="uploadSign()">
                        <span class="text-nowrap">Upload</span>
                    </b-button>
                </b-col>

                <b-col md="4">
                    <b-button variant="danger" class="mt-0 w-100" @click="clearSignature">
                        <span class="text-nowrap">Clear</span>
                    </b-button>
                </b-col>

                <b-col md="4">
                    <b-button variant="warning" class="mt-0 float-right w-100" @click="saveSignature">
                        <span class="text-nowrap">Submit</span>
                    </b-button>
                </b-col>
                
            </b-row>
            <!--<b-row class="mt-2">

                <b-col md="12">
                    <b-button variant="primary" class="mt-0 w-100" @click="uploadSign()">
                        <span class="text-nowrap">Submit all</span>
                    </b-button>
                </b-col>
                
            </b-row>-->
        </b-modal>
    </div>
</template>

<script>
import {
    BFormTextarea, BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,BAlert,BFormSelect,BFormSelectOption,BFormText,BInputGroupPrepend,BInputGroup,BMedia,BAvatar,BTable,BModal, BFormRadio,BFormTimepicker,BFormFile
} from 'bootstrap-vue';
import VueCropper from 'vue-cropperjs';
import Bus from "../../../event-bus";
import { POST_API } from "../../../store/actions.type"

export default{
    name: 'CrewSignature',
    components: {
        BFormTextarea, BAlert, BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BFormSelect, BFormSelectOption, BFormText, BInputGroupPrepend, BInputGroup, BMedia, BAvatar, BTable, BModal, VueCropper, BFormRadio, BFormTimepicker, BFormFile
    },
    props: ['index', 'tindex', 'signature'],
    data(){
        return{
            // signature vars
                doc_icon: require('@/assets/images/doc.png'),
                crewSign : this.signature,
                openedSignModelCrew:null,
        }
    },
    methods: {
        // signature functions
        hideSigantureCrew(){
            this.openedSignModelCrew = null;
        },

        openSignature(type){
            if (this.openedSignModelCrew == null) {
                this.$refs['signatureModelCrew'].show();
                this.openedSignModelCrew = type;
            }
        },

        uploadSign(){                
            if (this.openedSignModelCrew == 'supervisor') {
                this.$refs['supervisorSInput'].click();
            }
            if (this.openedSignModelCrew == 'client') {
                this.$refs['clientSInput'].click();
            }
            this.$refs['signatureModelCrew'].hide();
        },

        clearSignature(){
            this.$refs.signaturePad.clearSignature();
        },

        saveSignature(){
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if (isEmpty) {
                Swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'Signature is required',
                    showConfirmButton: false,
                    timer: 1500
                })
            }else{
                if (this.openedSignModelCrew == 'supervisor') {
                    this.crewSign.image = data;
                    this.crewSign.name = 'signature.png';
                    this.crewSign.type =  'supervisor';
                    this.crewSign.default = 'no';
                    //this.approveReport(this.crewSign);
                } else {
                    this.clientSign.image = data;
                    this.clientSign.name = 'signature.png';
                }
                    this.$refs['signatureModelCrew'].hide();
                                // send image data to parent
                Bus.$emit('update-imagecrew', {tindex: this.tindex, index: this.index, data: this.crewSign});
            }
        },
        approveReport(sign){

            return this.$store.dispatch(POST_API, {
                data:{
                    signature:sign,
                    id:this.id,
                    role:this.$store.getters.currentUser.role
                },
                api: '/api/approve-pedal-bin-report'
            })
            .then(() => {
                if (this.$store.getters.containsErrors) {
                    this.error_message = this.$store.getters.getErrors;
                    this.showDismissibleAlert = true;
                    window.scrollTo(0,0);
                } else {
                    this.showDismissibleAlert = false;
                    var data  = this.$store.getters.getResults.data;
                    
                    this.successAlert();
                    this.$refs.refUserListTable.refresh();

                    Bus.$emit('counter_update');
                    window.open(data,'_blank');
                }
            });
        },

        crewUpload(event){
            var input = event.target;
            var files = event.target.files

            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                var image = input.files[0];

                if (image.type != 'image/png' && image.type != 'image/jpeg' && image.type != 'image/jpg') {
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Please upload .png, .jpeg, .jpg images only',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    this.$refs.supervisorSInput.value=null;

                } else if (image.size > 2097152) {
                    Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Maximum 2 MB files allowed to be upload.',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.$refs.supervisorSInput.value=null;
                } else {
                    reader.onload = (e) => {
                        this.crewSign.image = e.target.result;
                        this.crewSign.name = image.name;
                        this.crewSign.type =  'supervisor';
                        this.crewSign.default = 'no';
                    }
                    // send image data to parent
                    var obj = {tindex:this.tindex, index: this.index, data: this.crewSign}
                    Bus.$emit('update-imagecrew', obj);
                }
            }
        },
            
        removeSign(sign){
            this.crewSign.image = null;
            this.crewSign.name = '';
            this.crewSign.default = 'no';
            Bus.$emit('remove-imagecrew', this.index, this.tindex);
        },
    },
    mounted(){
        // console.log(this.index);
    }
}
</script>
